$(document).ready(function() {
  $('li.flex.flex-col.items-center.text-center:last').hide();
    var btnhtml = $('.desktop-section-popup').html();
    var newContent = $(btnhtml).addClass('mobile-html');
    $('.product-block-title').after(newContent);
    setTimeout(function() {
        var price = $(".price-point.one_time_price").contents().first().text().trim();
        $('.org_prices').text(price);
        $('.Subscribe-section').addClass('active');
        $('.Subscribe-section').trigger('click');
    }, 2000);
    // $('.One-Time-Purchase-section').addClass('active');
   
    // $('.loop-widget-purchase-option-onetime').trigger('click');


    $('.Subscribe-section').click(function() {
        $('.Subscribe-section, .One-Time-Purchase-section').removeClass('active');
        $(this).addClass('active');
        $('.loop-widget-purchase-option-radio').trigger('click');
    });

    $('.One-Time-Purchase-section').click(function() {
        $('.Subscribe-section, .One-Time-Purchase-section').removeClass('active');
        $(this).addClass('active');
        $('.loop-widget-purchase-option-onetime').trigger('click');
    });


  

    $('#variants option').each(function() {
        const names = $(this).text().trim();
        const price = $(this).attr('data-price');

        $('.custom-button2').each(function() {
            var title = $(this).attr('title');
            if (names === title) {
                $(this).find('.prices').text(price);
                $(this).find('.hidden_org_prices').text(price);
            }
        });
    });
    $('.custom-button2').each(function(index) {
        var prices = $(this).find('.prices').text();
        var priceValue = parseFloat(prices.replace('$', '').trim());
        var dividedPrice = priceValue / (index + 1);
        $(this).find('.prices').text('$' + dividedPrice);
    });
    $('.custom-button2 input[type="radio"]:checked').each(function() {
        var ids = $(this).data('id');
        var pricing = $(this).attr('data-pricing');
        $('.product-variant-id').val(ids);
        $('.subs_price strong').text(pricing)
    });
    $('.custom-button2 input[type="radio"]').click(function() {
        var ids = $(this).data('id');
        $('.product-variant-id').val(ids);
    });
    $('.custom-button2').each(function() {
        var title = $(this).attr('title');
        var pricess = $(this).attr('data-price');
        if (title == 'Sans abonnement') {
            var idss = $(this).attr('data-variant-id');
            $('.left-one-time').attr('data-onetime', idss);
            $('.one_time_price').html(pricess);

        }
    });
    $('.left-one-time.checkbox').click(function() {
        var onetimeid = $(this).attr('data-onetime');
        $('.product-variant-id').val(onetimeid);
    });

          var price = parseFloat($('.one_time_price').text().replace('$', ''));
          let lastValue = $('.quantity-selector').attr('product-quantity');
          var maxQuantity = lastValue;
          var hiddenPrices = [];
          
          $('.hidden_org_prices').each(function () {
              var valss = parseFloat($(this).text().replace('$', ''));
              hiddenPrices.push(valss);
          });
          
          function updateTotalPrice() {
              var quantity = parseInt($('#Quantity').val(), 10);
              if (isNaN(quantity) || quantity < 1) {
                  quantity = 1;
              }
          
              var totalPrice = (price * quantity).toFixed(2);
          
              var storename = $(".custom-button2 input[type=radio]:checked").val();
              if (storename === 'Abonnement bimensuel') {
                  totalPrice = (totalPrice * 2).toFixed(2); 
              } else if (storename === 'Abonnement trimestriel') {
                  totalPrice = (totalPrice * 3).toFixed(2); 
              }
          
              $('.org_prices').text('$' + totalPrice);
              $('.one_time_price').html('$' + (price * quantity).toFixed(2)); 
          }
          
          $('#increase').on('click', function() {
              var quantity = parseInt($('#Quantity').val(), 10);
              if (quantity < maxQuantity) {
                  quantity++;
                  $('#Quantity').val(quantity);
                  updateTotalPrice();
                  $('.hidden_org_prices').each(function (index) {
                      var multiply = (hiddenPrices[index] * quantity).toFixed(2);
                      $(this).text('$' + multiply);
                  });
              }
          });
          
          $('#decrease').on('click', function() {
              var quantity = parseInt($('#Quantity').val(), 10);
              if (quantity > 1) {
                  quantity--;
                  $('#Quantity').val(quantity);
                  updateTotalPrice();
                  $('.hidden_org_prices').each(function (index) {
                      var multiply = (hiddenPrices[index] * quantity).toFixed(2);
                      $(this).text('$' + multiply);
                  });
              }
          });
          
          $('#Quantity').on('blur', function() {
              var currentVal = parseInt($('#Quantity').val(), 10);
              if (currentVal < 1 || isNaN(currentVal)) {
                  $('#Quantity').val(1);
              }
              if (currentVal > maxQuantity) {
                  $('#Quantity').val(maxQuantity);
              }
              updateTotalPrice();
              var quantity = parseInt($('#Quantity').val(), 10);
              $('.hidden_org_prices').each(function (index) {
                  var multiply = (hiddenPrices[index] * quantity).toFixed(2);
                  $(this).text('$' + multiply);
              });
          });
          
          $(".custom-button2 input[type=radio]").on('change', function() {
              updateTotalPrice();
          });



    $('.custom-button2 input[type="radio"]:checked').each(function() {
        var getmonth = $(this).attr('meta-values');
        $('.shipping_point').text(getmonth);
    });

    $('.custom-button2 input[type="radio"]').click(function() {
        var getmonth = $(this).attr('meta-values');
        $('.shipping_point').text(getmonth);
    });


});
setInterval(function() {
    var quantity = ($('#Quantity').val() || '').toString().trim();
    $('.var_quantity').val(quantity);
    
    var price = $('.custom-button2 input[type=radio]:checked')
        .closest('.custom-button2')
        .find('.hidden_org_prices')
        .text();
    
    $('.subs_price strong').text(price);

    var originalPrice = parseFloat($(".span-point.org_prices").text().replace('$', ''));
    var discountPrice = parseFloat($(".price-point.subs_price strong").text().replace('$', ''));
    var priceDifference  = originalPrice - discountPrice;
    $('.discount_price').html('$' + priceDifference.toFixed(2) + ' <sub class="saving-span">Rabais</sub>');

    if ($('.One-Time-Purchase-section').hasClass('active')) {
        $('#html').prop('checked', true);
    } else {
        $('#html').prop('checked', false);
    }
}, 500);
